import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

function extractValue(m, fallbacks = []) {
  if (m && typeof m === "object") {
    const keys = ["value", "address", "email", "username", "handle", "id"];
    for (const k of keys) {
      if (m[k] != null && String(m[k]).trim() !== "") return String(m[k]).trim();
    }
  }
  for (const f of fallbacks) {
    if (f != null && String(f).trim() !== "") return String(f).trim();
  }
  return "";
}

function extractLabel(m, fallback) {
  if (m && typeof m === "object" && m.label != null && String(m.label).trim() !== "") {
    return String(m.label).trim();
  }
  return fallback;
}

function extractColor(m, fallback) {
  if (m && typeof m === "object" && m.color != null && String(m.color).trim() !== "") {
    return String(m.color).trim();
  }
  return fallback;
}

function extractEnabled(m, fallback) {
  if (m && typeof m === "object" && typeof m.enabled === "boolean") return m.enabled;
  return fallback;
}

function extractUrl(m) {
  if (m && typeof m === "object" && m.url != null && String(m.url).trim() !== "") {
    return String(m.url).trim();
  }
  return "";
}

function ContactBox({label, value, href, bgColor}) {
  const safeHref = typeof href === "string" ? href : "";
  const isMailto = safeHref.startsWith("mailto:");

  return (
    <div className="contact-box" style={bgColor ? {backgroundColor: bgColor} : undefined}>
      <span className="contact-label">{label}:</span>
      {safeHref ? (
        <a
          className="contact-value"
          href={safeHref}
          {...(isMailto ? {} : {target: "_blank", rel: "noreferrer"})}
        >
          {value}
        </a>
      ) : (
        <span className="contact-value">{value}</span>
      )}
    </div>
  );
}

export default function Contact() {
  const {isDark} = useContext(StyleContext);

  const methods = (contactInfo && contactInfo.methods) || {};

  const emailValue = extractValue(methods.email, [contactInfo.email_address]);
  const emailLabel = extractLabel(methods.email, "Email");
  const emailColor = extractColor(methods.email, "#d93025");
  const emailEnabled = extractEnabled(methods.email, Boolean(emailValue));
  const emailHref = extractUrl(methods.email) || (emailValue ? `mailto:${emailValue}` : "");

  const discordValue = extractValue(methods.discord, []);
  const discordLabel = extractLabel(methods.discord, "Discord");
  const discordColor = extractColor(methods.discord, "#5865F2");
  const discordEnabled = extractEnabled(methods.discord, Boolean(discordValue));
  const discordHref = extractUrl(methods.discord);

  const hasAnyContact = (emailEnabled && emailValue) || (discordEnabled && discordValue);

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-header">
            <h1 className="heading contact-title">{contactInfo.title}</h1>

            <p className={isDark ? "dark-mode contact-subtitle" : "subTitle contact-subtitle"}>
              {contactInfo.subtitle}
            </p>

            <div className={isDark ? "dark-mode contact-text-div" : "contact-text-div"}>
              {/* Contact methods (Email / Discord) */}
              {hasAnyContact ? (
                <div className="contact-info-group">
                  {emailEnabled && emailValue ? (
                    <ContactBox label={emailLabel} value={emailValue} href={emailHref} bgColor={emailColor} />
                  ) : null}

                  {discordEnabled && discordValue ? (
                    <ContactBox label={discordLabel} value={discordValue} href={discordHref} bgColor={discordColor} />
                  ) : null}
                </div>
              ) : null}

              <br />
              <SocialMedia />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
